import 'underscore';
import feesActions from './fees-actions';
import { getSyiSlice } from 'tradera-state/configure-store';

function toIntOrNull(number) {
    var i = parseInt(number);
    if (isFinite(i)) {
        return i;
    }
    return null;
}

function isNullOrUndefined(val) {
    return _.isNull(val) || _.isUndefined(val);
}

const setOpeningBid = openingBid => dispatch => {
    dispatch({
        type: 'SET_OPENING_BID',
        payload: toIntOrNull(openingBid)
    });
};

const setFixedPrice = fixedPrice => dispatch => {
    dispatch({
        type: 'SET_FIXED_PRICE',
        payload: toIntOrNull(fixedPrice)
    });
};

const setReservePrice = reservePrice => dispatch => {
    dispatch({
        type: 'SET_RESERVE_PRICE',
        payload: toIntOrNull(reservePrice)
    });
    dispatch(feesActions.updatePrices());
};

const setAuctionBinPrice = auctionBinPrice => dispatch => {
    dispatch({
        type: 'SET_AUCTION_BIN_PRICE',
        payload: toIntOrNull(auctionBinPrice)
    });
};

const setAuctionBinPriceVisibility = visible => dispatch => {
    dispatch({
        type: 'SET_AUCTION_BIN_PRICE_VISIBILITY',
        payload: visible
    });
    if (!visible) {
        dispatch(setAuctionBinPrice(null));
    }
};

const setReservePriceVisibility = visible => dispatch => {
    dispatch({
        type: 'SET_RESERVE_PRICE_VISIBILITY',
        payload: visible
    });
    if (!visible) {
        dispatch(setReservePrice(null));
    }
};

const setIsPureBinSelected = isPureBinSelected => (dispatch, getState) => {
    dispatch({
        type: 'SET_IS_PURE_BIN_SELECTED',
        isPureBinSelected,
        isChangeItem: getSyiSlice(getState()).syi.isEditOfPublishedItem
    });
    if (isPureBinSelected) {
        dispatch(setOpeningBid(null));
        dispatch(setAuctionBinPrice(null));
        dispatch(setReservePrice(null));
    } else {
        dispatch(setFixedPrice(null));
    }
};

const setVat = vat => dispatch => {
    dispatch({
        type: 'SET_VAT',
        payload: vat
    });
};

const setFromDraft = (
    openingBid,
    fixedPrice,
    reservePrice,
    vat,
    isChangeItem
) => dispatch => {
    let hasOpeningBid = !isNullOrUndefined(openingBid);
    let hasFixedPrice = !isNullOrUndefined(fixedPrice);
    let hasReservePrice = !isNullOrUndefined(reservePrice);
    let isAuction = hasOpeningBid && !hasFixedPrice;
    let isAuctionBin = hasOpeningBid && hasFixedPrice;
    let isPureBin = !hasOpeningBid && hasFixedPrice;

    dispatch(setVat(vat));

    // TODO: fewer changes to the state makes the page load faster...
    if (isAuction) {
        dispatch(setOpeningBid(openingBid));
        dispatch(setReservePrice(reservePrice));
        dispatch(setAuctionBinPrice(null));
        dispatch(setFixedPrice(null));
        dispatch(setReservePriceVisibility(hasReservePrice));
        dispatch(setAuctionBinPriceVisibility(false));
        dispatch(setIsPureBinSelected(false));
    } else if (isAuctionBin) {
        dispatch(setOpeningBid(openingBid));
        dispatch(setReservePrice(reservePrice));
        dispatch(setAuctionBinPrice(fixedPrice));
        dispatch(setFixedPrice(null));
        dispatch(setReservePriceVisibility(hasReservePrice));
        dispatch(setAuctionBinPriceVisibility(true));
        dispatch(setIsPureBinSelected(false));
    } else if (isPureBin) {
        dispatch(setOpeningBid(null));
        dispatch(setReservePrice(null));
        dispatch(setAuctionBinPrice(null));
        dispatch(setFixedPrice(fixedPrice));
        dispatch(setReservePriceVisibility(false));
        dispatch(setAuctionBinPriceVisibility(false));
        dispatch(setIsPureBinSelected(true));
    } else {
        dispatch(setOpeningBid(null));
        dispatch(setReservePrice(null));
        dispatch(setAuctionBinPrice(null));
        dispatch(setFixedPrice(null));
        dispatch(setReservePriceVisibility(false));
        dispatch(setAuctionBinPriceVisibility(false));
        dispatch(setIsPureBinSelected(false));
    }

    dispatch({
        type: 'SET_RESERVE_PRICE_CAN_CHANGE_BUT_NOT_BE_REMOVED',
        payload: isChangeItem && hasReservePrice
    });
};

const reset = () => dispatch => {
    dispatch({
        type: 'RESET_PRICES_AND_VAT'
    });
};

export default {
    setOpeningBid,
    setFixedPrice,
    setReservePrice,
    setAuctionBinPrice,
    setAuctionBinPriceVisibility,
    setReservePriceVisibility,
    setIsPureBinSelected,
    setFromDraft,
    setVat,
    reset
};
